import OrganizationLayout from "../../modules/organization/organization-layout"
import OrganizationSubscriptions from "@/modules/organization/form-component/organization-subscriptions"

const OrganizationRouter = {
	path: "/organization",
	name: "organization",
	component: OrganizationLayout,
	children: [
		{
			path: "subscriptions",
			name: "organization.subscriptions",
			component: OrganizationSubscriptions,
			props: true
		}
	]
}

export default OrganizationRouter
